module.exports = __webpack_public_path__ + "static/media/welcome2.9c644ed2.png";